import { render, staticRenderFns } from "./personal_information.vue?vue&type=template&id=68effb25&scoped=true&"
import script from "./personal_information.vue?vue&type=script&lang=js&"
export * from "./personal_information.vue?vue&type=script&lang=js&"
import style0 from "./personal_information.vue?vue&type=style&index=0&id=68effb25&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68effb25",
  null
  
)

export default component.exports